// Клиентский BFF-слой домена `regions` (add-user-region, контракт C3 / A1).
//
// Own-origin `fetch('/api/regions/list')`:
//   • `credentials: 'same-origin'` — cookie прикрепляется браузером (guest OK без cookie);
//   • **НЕ** выставляет `Authorization` (AGENTS.md, ARCH-D-028);
//   • клиентский JS токен не читает.

import type { RegionsListResponse } from '@/lib/api/types';
import { clientFetch, parseApiResponse } from './client-fetch';

/** `GET /api/regions/list` — справочник enabled-регионов (контракт A1 / C3). */
export async function getRegions(): Promise<RegionsListResponse> {
  const res = await clientFetch('/api/regions/list', {
    credentials: 'same-origin',
    headers: { 'Cache-Control': 'no-store' },
  });
  return parseApiResponse<RegionsListResponse>(res);
}
